import React from 'react';
import InfoListingPage from '../components/InfoListingPage';

const items = [
  {
    title: 'Smeaton’s Tower & Hoe Park',
    distance: '0.3 miles and 6 minute walk from the hotel',
    image: 'Smeatons.jpg',
    description: 'No visit to Plymouth can be complete without visiting the iconic Smeaton Tower and taking a walk along the Hoe Promenade.'
  },
  {
    title: 'The Mayflower Steps',
    distance: '0.6 miles and 12 minute walk from the hotel',
    image: 'Mayflower.jpg',
    description: 'With the 400th anniversary of the Pilgrimage having just passed in 2020, a visit to The Mayflower Steps is a must. Flanked by British and American flags, the Steps are the point from which a group of 102 passengers, the Pilgrim Fathers, are believed to have set sail aboard the Mayflower on 6th September 1620 to seek religious and other freedoms in North America. More than 30 million people today can trace their ancestry to the Pilgrim Fathers and the Mayflower crew which landed in Plymouth, USA all those years ago!'
  },
  {
    title: 'Barbican Area',
    distance: '0.2 to 0.4 miles from the hotel',
    image: 'Barbican.jpg',
    description: 'The buzzing old town of Plymouth is a must-visit during your stay! With a wide range of delicious eateries, charming boutiques, and exciting bars, the Barbican area is considered to be amongst the happening parts of town. Walk along the docks to watch the boats bobbing around against the setting sun and your visit to Plymouth will feel complete.'
  },
  {
    title: 'Royal William Yard',
    distance: '0.6 miles and 13 minute walk from the hotel',
    image: 'RoyalWilliamYard.jpg',
    description: 'Dating as far back as the 1800s, the Royal William Yard is known to contain the prime collection of listed former Royal Navy buildings in Europe. After a multi-million pound restoration project, this historic building now hosts art galleries, cafes, bars and not to mention the lively monthly Plymouth Market which is located in the grounds right next this stunning piece of naval architecture!'
  },
  {
    title: 'Tinside Lido',
    distance: '0.4 miles and 8 minute walk from the hotel',
    image: 'TinsideLido.jpg',
    description: 'On a hot, lazy summer afternoon what can be better than a dip in the refreshing Tinside Lido, a saltwater swimming pool open between May and September each year. Voted as one of the top 10 outdoor pools in Europe, this easily accessible attraction from the Grosvenor Hotel Plymouth is not to be missed.'
  },
  {
    title: 'National Marine Aquarium',
    distance: '1.5 miles from the hotel',
    image: 'MarineAquarium.jpg',
    description: 'UK’s largest aquarium is situated at the entrance of the Sutton Harbour, Plymouth and has breathtaking views of the harbour. The aquarium has more than 40 tanks, including the deepest tank in Britain holding 2.5 million litres of water, and a touch pool where the young ones can get close to the smaller creatures. These tanks contain over 4000 animals including sharks, stingrays, barracuda, octopuses, sea horses, jellyfish and a cheeky turtle.'
  },
  {
    title: 'Plymouth Sound',
    distance: '0.5 miles and 10 minute walk from the hotel',
    image: 'PlymouthSound.jpg',
    description: 'A bay on the English Channel - Plymouth Sound, or locally just The Sound - offers picturesque views of Drake’s Island, Mount Batten and Mount Edgcumbe. At its southwest corner is Penlee Point in Cornwall and at its southeast corner is Wembury Point in Devon. Situated at the north of the Sound is Drake’s Island while at the northeast corner is Mount Batten, a former Royal Air Force flying boat and search and rescue base. The Sound is fed by River Tamar in the northwest and from the River Plym at northeast.'
  }
];

const PlymouthHighlights = () => (
  <InfoListingPage
    title="Plymouth’s Highlights"
    description="Make the most of your stay with some of Plymouth’s most iconic waterfront views, historic landmarks, and visitor favourites close to Grosvenor Plymouth."
    items={items}
  />
);

export default PlymouthHighlights;
